import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  branchName: string;
  indexHref: string;
};

export const EditBranchFormHeaderPresentation: React.FC<Props> = ({ branchName, indexHref }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '事業所', href: indexHref }, { label: `${branchName}の編集` }]}
  />
);
